import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable,
         FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { AdminAuthService } from '../../admin-auth.service';
import { slide } from '../../animations';

@Component({
  selector: 'app-show-company',
  templateUrl: './show-company.component.html',
  styleUrls: ['./show-company.component.scss'],
  animations: [slide]
})
export class ShowCompanyComponent implements OnInit {
  companyObservable: FirebaseObjectObservable<any>;
  galleryObservable: FirebaseListObservable<any>;
  usersObservable: FirebaseListObservable<any[]>;

  company: any;
  companyType: string;
  logoUrl: string;

  showModalBg = false;
  showFormModal = false;
  showInviteModal = false;
  showDeleteModal = false;
  showMemberFormModal = false;
  showDeleteMemberModal = false;
  showDeletePhotoModal = false;
  inviteeType;
  selectedMember;
  selectedPhoto;

  zoomView = false;
  zoomViewCompanyKey = null;
  zoomViewFileKey = null;
  uploadingPhoto = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService,
    private csService: CloudStorageService,
    private authService: AdminAuthService
  ) { }

  ngOnInit() {

    this.route.params.forEach((params: Params) => {
      this.companyObservable = this.dbService.getCompany(params['key']);
      this.galleryObservable = this.dbService.getVendorGallery(params['key']);

      this.companyObservable.subscribe(company => {
        this.company = company;
        this.companyType = company.companyType;
      });

      this.usersObservable = this.dbService.getCompanyUsers(params['key']);

    });
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  galleryFull() {
    this.company && this.company.gallery && Object.keys(this.company.gallery).length >= 12
  }

  onInviteClicked(inviteeType) {
    this.inviteeType = inviteeType;
    this.showInviteModal = true;
    this.showModalBg = true;
  }

  onHideInviteModal() {
    this.showInviteModal = false;
    this.showModalBg = false;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  userLevelType(member) {
    if (member.designation == "companyOwner" ||
        member.designation == "vendorOwner") {
      return "Owner";
    } else if (member.designation == "companyManager") {
      return "Manager";
    } else  {
      return "Employee";
    }
  }

  showMember(member) {
    this.router.navigate([`/members/${member.$key}`]);
  }

  onEditMemberClicked(member, event) {
    event.stopPropagation();
    this.selectedMember = member;
    this.showModalBg = true;
    this.showMemberFormModal = true;
  }


  onHideMemberFormModal() {
    this.showMemberFormModal = false;
    this.showModalBg = false;
  }

  onDeleteMemberClicked(member, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteMemberModal = true;
    this.selectedMember = member;
  }

  onConfirmDeleteMember() {
    this.onHideDeleteMemberModal();
    this.dbService.deleteMember(this.selectedMember.$key);
  }

  onHideDeleteMemberModal() {
    this.showDeleteMemberModal = false;
    this.showModalBg = false;
  }

  onPhotoUpload(event) {
    this.uploadingPhoto = true;
    let file = event.target.files[0];
    /*let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);*/
    this.dbService.addToVendorGallery(this.company, file)
                  .then( d => {
      this.uploadingPhoto = false;
    });

  }

  zoomPhoto(photo) {
    this.showModalBg = true;
    this.zoomView = true;
    this.zoomViewCompanyKey = this.company.$key;
    this.zoomViewFileKey = photo.$key;
  }

  closeZoomView() {
    this.showModalBg = false;
    this.zoomView = false;
    this.zoomViewCompanyKey = null;
    this.zoomViewFileKey = null;
  }

  deletePhoto(photo) {
    this.showModalBg = true;
    this.showDeletePhotoModal = true;
    this.selectedPhoto = photo;
  }

  onHideDeletePhotoModal() {
    this.selectedPhoto = null;
    this.showModalBg = false;
    this.showDeletePhotoModal = false;
  }

  onConfirmDeletePhoto() {
    this.dbService.removeVendorGalleryPhoto(this.company, this.selectedPhoto.$key);
    this.onHideDeletePhotoModal();
  }


}



// WEBPACK FOOTER //
// ./src/app/companies/show-company/show-company.component.ts